import React from 'react';
import { connect } from 'react-redux';

import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import { notEmpty } from 'utils/ramdaAdditions';
import { openModalProject } from 'actions/modalActions';

const PersonProjects = ({ partsInProject, openModalProject }) => notEmpty(partsInProject) && (
    <div>
        <DefinitionHeader translate="person.projects" iconType="case" />
        <div className="panel-view">
            { partsInProject.map((projectType, index) => (
                <div key={`project-type-${index}`}>
                    <b>{projectType.name}</b>
                    { notEmpty(projectType.parts) && projectType.parts.map((project, index) => (
                        <div key={`project-${index}`}>
                            <a onClick={() => openModalProject(project)}>{project.text}</a>
                        </div>
                    )) }
                </div>
            )) }
        </div>
    </div>
);

export default connect(null, { openModalProject })(PersonProjects);
